module.exports = __webpack_public_path__ + "img/image_05.bc213dec.png";